import { Attributes, Misc, ModelBase, Rules, Validation } from '@singularsystems/neo-core';
import InvestorInvestment from './InvestorInvestment';

export default class LiquidityProvider extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }

    public liquidityProviderId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    @Rules.Required()
    public investorInvestmentId: number | null = null;

    public investorInvestment: InvestorInvestment | null = null;

    @Attributes.Integer()
    public buyPriority: number = 0;

    @Attributes.Integer()
    public sellPriority: number = 0;

    @Attributes.Float()
    public maxHoldingPercent: number = 0;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public investorInvestmentName: string = "";

    @Rules.StringLength(10)
    public shortName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New liquidity provider";
        } else {
            return "Liquidity Provider";
        }
    }
}